import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shipping-delivery',
  templateUrl: './shipping-delivery.component.html',
  styleUrls: ['./shipping-delivery.component.scss']
})
export class ShippingDeliveryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
